module.exports = __webpack_public_path__ + "img/gd.008e1335.jpg";